import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5080/api';

const API = axios.create({
  baseURL: apiUrl,
});

// Oturum jetonu her istekte gönderilir (2026-08-20). Kullanıcı kimliği ve şube artık
// SUNUCUDA jetondan okunur; aşağıdaki X-Sube-Kod başlığı yalnızca henüz jeton yokken —
// yani login isteğinde — hangi şubenin TEKN tablosuna bakılacağını bildirmek için kalır.
API.interceptors.request.use(config => {
  const jeton = localStorage.getItem('jeton');
  if (jeton) config.headers['Authorization'] = `Bearer ${jeton}`;

  const subeKod = localStorage.getItem('subeKod');
  if (subeKod) config.headers['X-Sube-Kod'] = subeKod;
  return config;
});

// Jeton süresi dolduğunda (12 saat) veya geçersizse sunucu 401 döner: oturum temizlenip
// login ekranına dönülür. 403 ise oturum geçerli ama o ekran için yetki yok — kullanıcıyı
// dışarı atmaya gerek yok, ekran kendi hata mesajını gösterir.
API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !window.location.pathname.endsWith('/login')) {
      localStorage.removeItem('jeton');
      localStorage.removeItem('kullanici');
      localStorage.removeItem('subeKod');
      window.location.href = `${process.env.REACT_APP_BASENAME || ''}/login`;
    }
    return Promise.reject(err);
  }
);

export const getSubeler = () => API.get('/Sube/liste');
export const getPersoneller = () => API.get('/Personel');
export const girisYap = (kullaniciAdi, sifre) => API.post('/Auth/giris', { kullaniciAdi, sifre });
export const getPanelOzet = () => API.get('/Panel/ozet');

// İzin
export const getIzinHafta = (haftaBaslangici) => API.get('/Izin/hafta', { params: { haftaBaslangici } });
export const izinOlustur = (dto) => API.post('/Izin', dto);
export const izinAralikOlustur = (dto) => API.post('/Izin/aralik', dto);
export const izinGuncelle = (id, dto) => API.put(`/Izin/${id}`, dto);
export const izinSil = (id) => API.delete(`/Izin/${id}`);
export const getYarimGunSecenekleri = (tarih) => API.get('/Izin/yarim-gun-secenekleri', { params: { tarih } });

// Shift
export const getShiftHafta = (haftaBaslangici) => API.get('/Shift/hafta', { params: { haftaBaslangici } });
export const shiftHaftalikOlustur = (haftaBaslangici) => API.post('/Shift/haftalik-olustur', { haftaBaslangici });
export const shiftGunDegistir = (dto) => API.put('/Shift/gun', dto);
export const shiftGunSil = (dokKod, tarih) => API.delete('/Shift/gun', { params: { dokKod, tarih } });
export const shiftHaftaTemizle = (haftaBaslangici) => API.delete('/Shift/hafta', { params: { haftaBaslangici } });
export const getShiftSecenekleri = (tarih) => API.get('/Shift/secenekler', { params: { tarih } });
export const partListesiGetir = (dto) => API.post('/Shift/part-listesi', dto);
export const partShiftAc = (dto) => API.post('/Shift/part-shift-ac', dto);

// Uygun Randevu Bulucu
export const getUygunRandevuHizmetleri = () => API.get('/UygunRandevu/hizmetler');
export const uygunRandevuAra = (tarih, hizmetKod, sadeceDaimi) => API.get('/UygunRandevu/ara', { params: { tarih, hizmetKod, sadeceDaimi } });

// Etkinlik Hasta Kaydı (CALLCENTER.BENIARA, SBKOD=11 + ELLEGIRIS=1)
export const getEtkinlikListesi = (baslangic, bitis) => API.get('/Etkinlik', { params: { baslangic, bitis } });
export const etkinlikOlustur = (dto) => API.post('/Etkinlik', dto);
export const etkinlikSil = (id) => API.delete(`/Etkinlik/${id}`);

// Randevu Listesi (RAND tablosu, salt okunur)
export const getRandevuFiltreleri = () => API.get('/RandevuListesi/filtreler');
export const getRandevuListesi = (params) => API.get('/RandevuListesi', { params });
// Listeden seçilen randevunun hastasına tek SMS (2026-09-21).
export const randevuSmsGonder = (randId, mesaj) => API.post(`/RandevuListesi/${randId}/sms`, { mesaj });

// Harcama Kaydı (CHK / CHI / MASTERJOB — canlı muhasebe tabloları)
export const getHarcamaSecenekleri = () => API.get('/Harcama/secenekler');
export const harcamaKaydet = (dto) => API.post('/Harcama', dto);

// Harcama Kaydı Gelişmiş (YETK_WEB_10)
export const getHarcamaListesi = (params) => API.get('/Harcama/liste', { params });
export const getHarcamaKaydedenler = () => API.get('/Harcama/kaydedenler');
// Kaydı İPTAL eder (CHI.IPTAL=1); satırlar silinmez, geri alınabilir.
export const harcamaIptalEt = (masterProtNo) => API.delete(`/Harcama/${masterProtNo}`);

// Call Center (CALLCENTER.BENIARA — şubeden bağımsız)
export const getCallCenterSecenekleri = () => API.get('/CallCenter/secenekler');
export const getCallCenterListesi = (params) =>
  API.get('/CallCenter', { params, paramsSerializer: { indexes: null } });
export const getCallCenterDetay = (id) => API.get(`/CallCenter/${id}`);
export const callCenterGuncelle = (id, dto) => API.put(`/CallCenter/${id}`, dto);
export const callCenterOlustur = (dto) => API.post('/CallCenter', dto);
export const callCenterSil = (id) => API.delete(`/CallCenter/${id}`);
// Biçimlendirilmiş .xlsx sunucuda üretilir (renkler, kenarlıklar, sütun genişlikleri);
// tarayıcıya hazır dosya olarak iner.
export const getCallCenterExcel = (params) =>
  API.get('/CallCenter/excel', { params, paramsSerializer: { indexes: null }, responseType: 'blob' });
export const callCenterAlanGuncelle = (id, alan, deger) =>
  API.patch(`/CallCenter/${id}/alan`, { deger }, { params: { alan } });

// SMS altyapısı (CALLCENTER.SMS_AYAR — tüm ekranlar buradan gönderir, yetki YETK_WEB_12)
export const getSmsDurum = () => API.get('/Sms/durum');
export const smsGonder = (numara, mesaj) => API.post('/Sms/gonder', { numara, mesaj });
export const smsOnizleme = (mesaj) => API.post('/Sms/onizleme', { numara: '', mesaj });

// Kişisel Asistan — sesli hatırlatıcı (CALLCENTER.HATIRLATMA, yetki YETK_WEB_21)
export const hatirlatmaListe = (params) => API.get('/Hatirlatma', { params });
export const hatirlatmaOzet = () => API.get('/Hatirlatma/ozet');
export const hatirlatmaSes = (id) => API.get(`/Hatirlatma/${id}/ses`, { responseType: 'blob' });
// Sekreterin sabit cümleleri (bir kez seslendirilir): kayit-basla, kayit-tamam, soru, erken, onayli, cevap-<karar>
// ?s=2: 2026-09-18'de sesler sonlarına duraklama eklenerek yeniden üretildi; telefonun eski
// önbelleği atlansın diye sürüm. Sesler yeniden üretilirse artırılır.
export const hatirlatmaSabitSes = (anahtar) => API.get(`/Hatirlatma/sabit-ses/${anahtar}`, { params: { s: 2 }, responseType: 'blob' });
const sesFormu = (blob, dosyaAdi) => { const f = new FormData(); f.append('ses', blob, dosyaAdi); return f; };
export const hatirlatmaSesli = (blob, dosyaAdi) => API.post('/Hatirlatma/sesli', sesFormu(blob, dosyaAdi));
export const hatirlatmaCevap = (id, blob, dosyaAdi) => API.post(`/Hatirlatma/${id}/cevap`, sesFormu(blob, dosyaAdi));
export const hatirlatmaKarar = (id, karar, saat) => API.post(`/Hatirlatma/${id}/karar`, { karar, saat });
export const hatirlatmaEkle = (veri) => API.post('/Hatirlatma', veri);
export const hatirlatmaGuncelle = (id, veri) => API.put(`/Hatirlatma/${id}`, veri);
export const hatirlatmaGeriAl = (id) => API.post(`/Hatirlatma/${id}/geri-al`);
export const hatirlatmaSil = (id) => API.delete(`/Hatirlatma/${id}`);
export const hatirlatmaBildirimAnahtari = () => API.get('/Hatirlatma/bildirim-anahtari');
export const hatirlatmaAbone = (abonelik) => API.post('/Hatirlatma/abone', abonelik);
export const hatirlatmaAboneSil = (endpoint) => API.post('/Hatirlatma/abone-sil', { endpoint });
export const hatirlatmaTestBildirim = () => API.post('/Hatirlatma/test-bildirim');

export default API;
